import React from 'react';
import Sidebar from './Sidebar';

const Layout = ({ children }) => {
  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <div className="flex-1 bg-slate-50 min-h-screen overflow-auto">
        {children}
      </div>
    </div>
  );
};

export default Layout;
